export default __webpack_public_path__ + "static/media/icon_doorsign.0fe988f8.svg";